<section class="sequence-diagram-container">
  <app-sidebar></app-sidebar>

  <div class="mobile-tabs">
    <button type="button" class="tab-button" [class.active]="activeTab === 'editor'" (click)="setActiveTab('editor')">📝 Éditeur</button>
    <button type="button" class="tab-button" [class.active]="activeTab === 'canvas'" (click)="setActiveTab('canvas')">🎨 Diagramme</button>
  </div>

  <section class="diagram-editor">
    <app-toolbar [actions]="toolbarActions"></app-toolbar>

    <div class="editor-canvas-wrapper" #container>
      <app-editor #editor [class.active]="activeTab === 'editor'"></app-editor>
      <div class="resizer" #resizer></div>
      <app-diagram-canvas #canvas [class.active]="activeTab === 'canvas'"></app-diagram-canvas>

      @if (showHelpModal) {
        <app-diagram-help-modal (close)="closeHelpModal()"></app-diagram-help-modal>
      }
    </div>
  </section>
</section>
